import axios from "axios";
import Cookies from "js-cookie";
import config from "../config";

const getAxios = () => {
  return axios.create({
    baseURL: config.REACT_APP_BASE_URL,
    headers: {
      Accept: "application/json",
      ...(Cookies.get("x-admin-auth") && {
        Authorization: `Bearer ${Cookies.get("x-admin-auth")}`,
      }),
      // ...(Cookies.get('Zippy-org') && { "X-Membership-Id": JSON.parse(Cookies.get('Zippy-org') as string).membership_id })
    },
  });
};

export default getAxios;
